export enum ConnectionState {
	TO_CONNECT = 'to_connect',
	CONNECTING = 'connecting',
	CONNECTED = 'connected',
	CLOSING = 'closing',
	CLOSED = 'closed',
}
